module.exports = __webpack_public_path__ + "static/media/ic_switch_full_screen.e9f2ccd0.svg";